var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-screen"},[_c('img',{attrs:{"src":_vm.iconImage}}),(_vm.textString)?_c('text-string',{staticClass:"text-center",attrs:{"label-id":_vm.textString}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }